import * as ActionUtility from '@utilities/action-utility'
import * as Effects from './address-step-effect'

const REQUEST_GET_ADDRESS = 'Aberto.Onboarding.REQUEST_GET_ADDRESS'
const REQUEST_GET_ADDRESS_FINISHED = 'Aberto.Onboarding.REQUEST_GET_ADDRESS_FINISHED'
const SET_ADDRESS_FIELD = 'Aberto.Onboarding.SET_ADDRESS_FIELD'

const getAddress = zipCode => {
  return async dispatch => {
    await ActionUtility.createThunkEffect(dispatch, REQUEST_GET_ADDRESS, Effects.getAddress, zipCode)
  }
}

const setAddressField = (name, value) => {
  return ActionUtility.createAction(SET_ADDRESS_FIELD, { name, value })
}

export { setAddressField, SET_ADDRESS_FIELD, getAddress, REQUEST_GET_ADDRESS, REQUEST_GET_ADDRESS_FINISHED }
